<template>
  <button
    type="button"
    role="switch"
    :aria-checked="value ? 'true' : 'false'"
    :disabled="disabled"
    class="switch-v2 w-9 h-5 p-0.5 m-0 flex items-center shrink-0 rounded-full border-0 transition-colors"
    :class="[
      value ? 'bg-green-500' : 'bg-gray-200',
      disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
    ]"
    @click="onClick"
  >
    <span
      class="block w-4 h-4 rounded-full bg-white transition-transform"
      :class="value ? 'ltr:translate-x-4 rtl:-translate-x-4' : ''"
    />
  </button>
</template>

<script>
export default {
  name: 'SwitchV2',
  props: {
    value: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    onClick() {
      if (this.disabled) return;
      this.$emit('input', !this.value);
    },
  },
};
</script>
